import { network } from 'services/network';
import { useMutation } from 'react-query';
import { QueryResponse } from 'api/queries/getPrefferedSPIMethod.query';
import qs from 'qs';

const mutationFn = (params: QueryParams) => {
    const querystring = qs.stringify(params, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/setSubProgramPreferenceProgressScurve${querystring}`;
    return network.post(url).then((response) => {
        return response.data;
    });
};

export const useMutationSetSubProgramPreferenceProgressScurve = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    subProgramId: number;
    option: QueryResponse;
}
